import { Box, Skeleton, Typography } from '@mui/material';
import React from 'react';

interface TopSectionBoardsProps {
  title: string;
  description?: string;
  loading?: boolean;
  leftAction?: React.ReactNode;
  rightAction?: React.ReactNode;
}

const TopSectionBoards: React.FC<TopSectionBoardsProps> = ({
  title,
  description,
  loading = false,
  leftAction,
  rightAction,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        minHeight: 56,
        px: 2,
        py: 2,
        borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
        mb: 3,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {leftAction}
        <Box sx={{ px: leftAction ? 2 : 0, py: 2 }}>
          {loading ? (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
              }}
            >
              <Box>
                <Skeleton
                  variant="rectangular"
                  width={220}
                  height={32}
                  sx={{ borderRadius: 2 }}
                />
              </Box>
              <Skeleton
                variant="rectangular"
                width={320}
                height={20}
                sx={{ borderRadius: 2 }}
              />
            </Box>
          ) : (
            <>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  fontSize: { xs: '1.1rem', md: '1.25rem' },
                  color: (theme) => theme.palette.text.primary,
                }}
                noWrap
              >
                {title}
              </Typography>
              {description && (
                <Box>
                  <Typography
                    variant="body2"
                    sx={{ color: (theme) => theme.palette.text.secondary }}
                  >
                    {description}
                  </Typography>
                </Box>
              )}
            </>
          )}
        </Box>
      </Box>
      {rightAction && <Box>{rightAction}</Box>}
    </Box>
  );
};

export default TopSectionBoards;
